import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { PopularPackages } from "@/components/PopularPackages";
import { ManifestoChapters } from "@/components/ManifestoChapters";
import { TestimonialsCarousel } from "@/components/TestimonialsCarousel";
import { EnquiryFormSection } from "@/components/EnquiryFormSection";
import { FlyerShowcase } from "@/components/FlyerShowcase";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { scrollToId, scrollToTop } from "@/lib/scroll";

export default function HomePage() {
  const [enquiryService, setEnquiryService] = useState("domestic");
  const [enquiryDate, setEnquiryDate] = useState("");
  const [enquiryPackage, setEnquiryPackage] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo || (location.hash ? location.hash.slice(1) : null);
    if (location.state?.service) setEnquiryService(location.state.service);
    if (location.state?.travelDate) setEnquiryDate(location.state.travelDate);
    if (location.state?.packageId) setEnquiryPackage({ id: location.state.packageId, title: location.state.packageTitle });
    if (target === "__top") {
      const timer = setTimeout(() => scrollToTop(), 150);
      return () => clearTimeout(timer);
    }
    if (target) {
      const timer = setTimeout(() => scrollToId(target), 400);
      // second pass once images/layout settle, so the section lands under the navbar offset
      const timer2 = setTimeout(() => scrollToId(target), 1600);
      return () => { clearTimeout(timer); clearTimeout(timer2); };
    }
    // plain navigation home (logo click from another page) — land at the top
    scrollToTop();
  }, [location]);

  const handleEnquire = (serviceType) => {
    setEnquiryService(serviceType);
    scrollToId("enquiry");
  };

  return (
    <div className="bg-ink text-cream grain-overlay" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <EditorialMarquee />
      <FlyerShowcase />
      <PopularPackages onEnquire={handleEnquire} />
      <ManifestoChapters />
      <TestimonialsCarousel />
      <EnquiryFormSection service={enquiryService} setService={setEnquiryService} initialDate={enquiryDate} packageInfo={enquiryPackage} />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
